// frontend/src/utils/currentSeason.js
// Shared helper for multi-season Anime/ScreenMedia (TV) items: picks the season that
// represents the user's actual current progress instead of always the last one.
//
// Rule: walk the seasons in order (season 1, 2, 3...) and use the first one that is not
// "Finished". If every season is Finished, the item as a whole is Finished.
//
// Seasons flagged `is_extra` (bonus/OVA/special content bundled alongside real seasons) are
// excluded from this calculation entirely - their own status never blocks the series from
// being considered "Finished", and they're never picked as the "current" season.
export const getCurrentSeason = (media) => {
  const seasons = media.seasons;
  if (!Array.isArray(seasons) || seasons.length <= 1) return media;
  const mainSeasons = seasons.filter((s) => !s.is_extra);
  if (mainSeasons.length === 0) return seasons[seasons.length - 1];
  const inProgress = mainSeasons.find((s) => (s.status || '').toLowerCase() !== 'finished');
  return inProgress || mainSeasons[mainSeasons.length - 1];
};

export const getSeasonTitle = (season) =>
  season.title_en || season.title_mal || season.title_tmdb || 'Unnamed Season';

// Non-bonus seasons only - use this for "how many seasons does this have" counts/labels so
// extras don't inflate the number or make a single-season show look multi-season.
export const getMainSeasons = (media) =>
  Array.isArray(media.seasons) ? media.seasons.filter((s) => !s.is_extra) : [];
